import { render, staticRenderFns } from "./lightbox-template-selection.vue?vue&type=template&id=08b946f3&scoped=true&"
import script from "./lightbox-template-selection.vue?vue&type=script&lang=js&"
export * from "./lightbox-template-selection.vue?vue&type=script&lang=js&"
import style0 from "./lightbox-template-selection.vue?vue&type=style&index=0&id=08b946f3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b946f3",
  null
  
)

export default component.exports